const Instrucao = () => {
    return (
      <div>
        <h2>Instruções para Preenchimento</h2>
  
        <p>
          <em>
            Preencha os campos abaixo com o total de energia consumida pela empresa no ano objeto dessa coleta de dados, segregando a energia por fonte.
            Os volumes de energia de cada fonte deverão ser convertidos para GJ (cada fonte de energia tem um fator de conversão específico).
          </em>
        </p>
  
        <h3>Grupos de Energia</h3>
  
        <p>Os campos são divididos em cinco grupos:</p>
  
        <p><strong>1 – Combustível Renovável</strong></p>
        <p><strong>2 – Combustível Não-Renovável</strong></p>
        <p><strong>3 – Eletricidade Renovável</strong></p>
        <p><strong>4 – Eletricidade Não-Renovável</strong></p>
        <p><strong>5 – Eletricidade SIN</strong> (Sistema Interligado Nacional)</p>
  
        <h3>1 e 2 - Combustíveis</h3>
  
        <p>
          <strong>Os grupos 1 e 2 estão relacionados a combustíveis.</strong> Aqui você deve converter todos os combustíveis utilizados na empresa para GJ 
          e preencher os campos de acordo com a natureza do combustível (renovável ou não-renovável).
        </p>
  
        <p>
          <strong>Observação:</strong> Como o diesel no Brasil possui um percentual de biodiesel,
          você deve separar o GJ correspondente ao biodiesel no grupo de combustível renovável.
          O GJ correspondente ao diesel puro deve ser alocado no grupo de combustível não-renovável.
        </p>
  
        <blockquote>
          Exemplo:  
          A empresa consumiu <strong>1000 litros de diesel B12</strong> (12% biodiesel).  
          - 120 litros de <strong>Biodiesel B100</strong> → Fator de conversão: 0.033107295 GJ/litro → <strong>3.97 GJ</strong>  
          - 880 litros de <strong>Óleo Diesel Puro</strong> → Fator de conversão: 0.03612 GJ/litro → <strong>31.78 GJ</strong>
        </blockquote>
  
        <h3>3, 4 e 5 - Eletricidade</h3>
  
        <p>
          <strong>Os grupos 3, 4 e 5 estão relacionados à eletricidade consumida.</strong> A fonte da eletricidade
          pode ser renovável ou não-renovável. Se a empresa possuir um contrato detalhando a fonte de sua energia,
          os valores devem ser registrados separadamente (em GJ).
        </p>
  
        <blockquote>
          Exemplo:  
          Uma empresa possui um contrato no mercado livre com:  
          - 1000 kWh de geração eólica + 1000 kWh de geração por biomassa, assim deve ser preenchido:
          <br></br>Da geração eólica: Conversão: 1000 kWh × 0.0036 GJ/kWh = <strong>3.6 GJ no campo Eólicas</strong>.
          <br></br>Do bagaço de cana: Conversão: 1000 kWh × 0.0036 GJ/kWh = <strong>3.6 GJ no campo Biomassa - bagaço de cana</strong>.
        </blockquote>
  
        <p>
          Se a empresa não especificar a origem da eletricidade, deve registrar o consumo no grupo 
          <strong> 5 – Eletricidade SIN</strong>, onde será utilizado o percentual médio de energia renovável do sistema brasileiro.
        </p>
  
        <h3>Autoprodução de Energia</h3>
  
        <p>
          Se a empresa gerar eletricidade para consumo próprio utilizando combustíveis,
          a energia deve ser registrada nos grupos 1 ou 2, conforme o tipo de combustível utilizado.
          Nesse caso, deverá ser aplicado o fator de conversão, para GJ, do combustível utilizado
          para a geração de energia elétrica. A energia só será registrada nos grupos 3 ou 4 se existir
          um contrato de fornecimento de energia elétrica, ou seja, se a empresa comprar kWh ao invés
          de litros ou toneladas de combustível.
        </p>
      </div>
    );
};

export default Instrucao;